import axios from '@/api/config';
const classInfoOrderInfo={
  addClassInfoOrderInfo(data){
    return  axios.post(`${process.env.BASE_URL}/classInfoOrderInfo/addClassInfoOrderInfo`,data)
  },
  pageList(data){
    return  axios.post(`${process.env.BASE_URL}/classInfoOrderInfo/pageList`,data)
  },
  deleteClassInfoOrderInfo(data){
    return  axios.delete(`${process.env.BASE_URL}/classInfoOrderInfo/deleteClassInfoOrderInfo`,{data:data})
  },
  updateClassInfoOrderInfo(data){
    return  axios.put(`${process.env.BASE_URL}/classInfoOrderInfo/updateClassInfoOrderInfo`,data)
  },
}
export default classInfoOrderInfo



// WEBPACK FOOTER //
// ./src/api/classInfoOrderInfo.js